// Third-party
import React, { ReactElement } from 'react';
import { formatLocalizedString } from '@/utils/i18n/i18n';
import useThemeVersion from '@/hooks/useThemeVersion';

// Components
import { ControlItem, Tabs } from '@/views/components/navigation';

// Legacy component
import LegacyDataSourceTabs from '@/views/components/data-source/LegacyDataSourceTabs';

// Types
import { DataSourceTabs as DataSourceTabsType } from '@/types/app-config';

type Props = {
  disabled?: boolean;
  value: string;
  tabs: DataSourceTabsType[];
  onChange: (value: string) => void;
};

type LegacyProps = {
  dark?: boolean;
};

type WrapperProps = Props & LegacyProps;

/**
 * A component that maps toggle buttons to specific Data Sources
 */
const DataSourceTabsV2 = ({ disabled, tabs, value, onChange }: Props): ReactElement => (
  <Tabs className="tabs-v2" disabled={disabled} onChange={onChange} selected={value}>
    {tabs.map(tab => (
      <ControlItem key={tab.value} value={tab.value} aria-selected={value === tab.value} role="tab">
        {formatLocalizedString(tab.label)}
      </ControlItem>
    ))}
  </Tabs>
);

const DataSourceTabs = (props: WrapperProps): ReactElement => {
  const { isLightVersion } = useThemeVersion();
  if (isLightVersion) {
    return <DataSourceTabsV2 {...props} />;
  }
  return <LegacyDataSourceTabs {...props} />;
};

export default DataSourceTabs;
